import api from '@/api/services/api'

const getUsers = params => api({
  method: 'get',
  url: 'bitrix/rex/events/users',
  params
})

const createLead = data => api({
  method: 'post',
  url: 'bitrix/rex/events/addLead',
  data
})

export {
  getUsers,
  createLead
}